import { Button, Input, Table, DatePicker } from "antd";

import React, { useEffect, useState } from "react";

import { SearchOutlined } from "@ant-design/icons";

import moment from "moment";

import DefectiveProductApi from "utils/composable/defectivePorductApi";

const BinTable = ({}) => {
  const [damagedProducts, setDamagedProducts] = useState([]);
  const [filteredData, setFilteredData] = useState(false);
  const [currentQuery, setCurrentQuery] = useState("");

  const fuzzyFilter = (query, product) => {
    setCurrentQuery(query);

    var get_bigrams, j, len, obj, relevance, results, string_similarity;

    get_bigrams = function (string) {
      var i, j, ref, s, v;
      s = string.toLowerCase();
      v = new Array(s.length - 1);
      for (i = j = 0, ref = v.length; j <= ref; i = j += 1) {
        v[i] = s.slice(i, i + 2);
      }
      return v;
    };

    string_similarity = function (str1, str2) {
      var hit_count, j, k, len, len1, pairs1, pairs2, union, x, y;
      if (str1.length > 0 && str2.length > 0) {
        pairs1 = get_bigrams(str1);
        pairs2 = get_bigrams(str2);
        union = pairs1.length + pairs2.length;
        hit_count = 0;
        for (j = 0, len = pairs1.length; j < len; j++) {
          x = pairs1[j];
          for (k = 0, len1 = pairs2.length; k < len1; k++) {
            y = pairs2[k];
            if (x === y) {
              hit_count++;
            }
          }
        }
        if (hit_count > 0) {
          return (2.0 * hit_count) / union;
        }
      }
      return 0.0;
    };

    if (query.length > 2) {
      results = [];

      for (j = 0, len = damagedProducts.length; j < len; j++) {
        var damagedProduct = damagedProducts[j];

        if (product) {
          relevance = string_similarity(
            query,
            damagedProduct.product?.name || ""
          );
        } else {
          relevance = string_similarity(
            query,
            damagedProduct?.client?.name || ""
          );
        }

        obj = {
          ...damagedProduct,
          relevance: relevance,
        };
        results.push(obj);
      }

      var sortedResults = results.filter((result) => result.relevance > 0.2);

      sortedResults = sortedResults
        .sort((a, b) => a.relevance - b.relevance)
        .reverse();

      damagedProduct = [...sortedResults];
      setFilteredData(sortedResults);
      console.log(results);
    }
  };

  const { getBinProductsApi } = DefectiveProductApi();

  var products = [];

  useEffect(() => {
    getBinProductsApi().then((damagedProducts) => {
      products = damagedProducts;
      console.log(damagedProducts);

      setDamagedProducts(damagedProducts.damagedProducts.reverse());
    });
  }, []);

  const columns = [
    {
      title: "Product",
      render: (record) => record?.product.name,

      key: "6",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                // confirm();

                fuzzyFilter(selectedKeys[0], true);
              }}
              onBlur={() => {
                fuzzyFilter(selectedKeys[0], true);
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                fuzzyFilter(selectedKeys[0], true);
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });

                setFilteredData(false);
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
    },

    {
      title: "Barcode",
      render: (record) => record?.product.barcode,
      key: "1",
      width: "20%",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target?.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        console.log({ record }, "record");

        return record?.product?.barcode

          ?.toLowerCase()
          .includes(value.toLowerCase());
      },
    },

    {
      title: "Date",

      key: "Date",
      width: "20%",
      render: (record) => moment(record?.createdAt).format("DD-MM-YYYY"),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <DatePicker
              style={{ margin: "1rem" }}
              autoFocus
              value={
                selectedKeys[0] ? moment(selectedKeys[0], "DD-MM-YYYY") : null
              }
              format={"DD-MM-YYYY"}
              onChange={(date, dateString) => {
                setSelectedKeys(dateString ? [dateString] : []);
              }}
              onOk={() => {
                confirm();
              }}
              placeholder="Select date"
            />
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        return moment(record?.createdAt).format("DD-MM-YYYY").includes(value);
      },
    },

    {
      title: "Client",

      key: "2",
      render: (record) => record?.client.name,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                // confirm();

                fuzzyFilter(selectedKeys[0], false);
              }}
              onBlur={() => {
                fuzzyFilter(selectedKeys[0], false);
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                fuzzyFilter(selectedKeys[0], false);
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });

                setFilteredData(false);
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },

      filterIcon: () => {
        return <SearchOutlined />;
      },
    },
  ];

  return (
    <>
      <Table
        key={damagedProducts?._id}
        rowKey={"_id"}
        columns={columns}
        pagination={true}
        dataSource={filteredData ? filteredData : [...damagedProducts]}
      />
    </>
  );
};

export default BinTable;
